import React, { useState } from 'react';
import './WelcomeModal.css';

const PAGES = [
  {
    title: 'Welcome to The Realms of Loria!',
    icon: '🏰',
    content: (
      <>
        <p><strong>Castle Antaria stands. The dungeon below it does not.</strong></p>
        <p>An old wound is reopening beneath the city, the bandits on the road outside are only the first of its tells, and the Founding Accord that holds the realm together is one bad week from cracking. The King is hiring.</p>
        <p>Let's get you ready — the basics only take a moment.</p>
      </>
    ),
  },
  {
    title: 'Moving Around',
    icon: '🧭',
    content: (
      <>
        <div className="wm-key-row">
          <kbd>W</kbd><kbd>A</kbd><kbd>S</kbd><kbd>D</kbd>
          <span className="wm-or">or</span>
          <kbd>↑</kbd><kbd>←</kbd><kbd>↓</kbd><kbd>→</kbd>
        </div>
        <p>Use <strong>WASD</strong> or <strong>arrow keys</strong> to move around the world.</p>
        <p>Walk into <strong>NPCs</strong> (characters on the map) to talk to them. Conversations can give you quests, items, and story!</p>
      </>
    ),
  },
  {
    title: 'Combat & Cards',
    icon: '⚔️',
    content: (
      <>
        <p>When you encounter a monster, combat begins! Battles use a <strong>card system</strong>.</p>
        <div className="wm-card-demo">
          <div className="wm-card">🗡️ Attack</div>
          <div className="wm-card">🔥 Fire Bolt</div>
          <div className="wm-card">🛡️ Defend</div>
        </div>
        <p><strong>Click a card</strong> to play it. Each card costs <strong>AP</strong> (Action Points) — you get 3 per turn.</p>
        <p>When you're done, click <strong>End Turn</strong>.</p>
      </>
    ),
  },
  {
    title: 'Your Quest Log',
    icon: '📜',
    content: (
      <>
        <p>Press <kbd>J</kbd> to open your <strong>Compendium</strong> — it tracks all your quests, showing what to do and where to go.</p>
        <p>You can also open it from the 📖 <strong>Adventure</strong> button in the top navigation bar (Quests tab).</p>
        <div className="wm-hotkey-list">
          <div><kbd>I</kbd> — Inventory</div>
          <div><kbd>J</kbd> — Quest Log</div>
          <div><kbd>K</kbd> — Skill Tree</div>
          <div><kbd>C</kbd> — Character Sheet</div>
        </div>
      </>
    ),
  },
  {
    title: 'Death & Homepoints',
    icon: '💀',
    content: (
      <>
        <p><strong>Falling in battle isn't game over.</strong> You respawn at your homepoint with full HP — your <strong>gear, gold, and level are safe</strong>. You'll lose a small slice of XP, but never enough to drop a level.</p>
        <p>Your homepoint starts on the forest road; visit a <strong>temple or shrine</strong> to set a closer one. Check it any time on your Character Sheet (<kbd>C</kbd>).</p>
      </>
    ),
  },
  {
    title: 'You\'re Ready!',
    icon: '✨',
    content: (
      <>
        <p>That's all you need to know to get started!</p>
        <p>Look for the <strong>quest objective</strong> tracker at the top of your screen — it'll guide you on what to do next.</p>
        <p>Good luck, adventurer. The Realms of Loria await! 🏰</p>
      </>
    ),
  },
];

const WelcomeModal = ({ onClose, characterId }) => {
  const [page, setPage] = useState(0);
  const current = PAGES[page];
  const isLast = page === PAGES.length - 1;
  const storageKey = `loria_welcome_seen_${characterId || 'default'}`;

  const handleNext = () => {
    if (isLast) {
      localStorage.setItem(storageKey, '1');
      onClose();
    } else {
      setPage(p => p + 1);
    }
  };

  return (
    <div className="wm-overlay">
      <div className="wm-modal">
        <div className="wm-progress">
          {PAGES.map((_, i) => (
            <div key={i} className={`wm-dot${i === page ? ' wm-dot-active' : i < page ? ' wm-dot-done' : ''}`} />
          ))}
        </div>
        <div className="wm-icon">{current.icon}</div>
        <h2 className="wm-title">{current.title}</h2>
        <div className="wm-content">{current.content}</div>
        <div className="wm-buttons">
          {page > 0 && (
            <button className="wm-btn wm-btn-back" onClick={() => setPage(p => p - 1)}>← Back</button>
          )}
          <button className="wm-btn wm-btn-next" onClick={handleNext}>
            {isLast ? 'Begin Adventure →' : 'Next →'}
          </button>
        </div>
        <button className="wm-skip" onClick={() => { localStorage.setItem(storageKey, '1'); onClose(); }}>
          Skip intro
        </button>
      </div>
    </div>
  );
};

export default WelcomeModal;
